import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Normalise a user-entered URL so it carries an https:// scheme. Used by the
 * website / Facebook / Instagram fields so a bare "facebook.com/foo" is saved
 * as "https://facebook.com/foo". Leaves an existing http(s):// scheme intact
 * and an empty value empty.
 */
export function ensureHttps(raw: string): string {
  const v = (raw || "").trim();
  if (!v) return "";
  if (/^https?:\/\//i.test(v)) return v;
  return `https://${v.replace(/^\/+/, "")}`;
}
